import { getLocaleByHost } from '@bscom/locales';

import { BusinessSiteProvider, buildTranslations } from 'lib/app-setup';

import 'react-context-modals/dist/main.css';

function MyApp({ Component, pageProps = {}, locale, translations }) {
  const localeCode = locale.code;

  return (
    <BusinessSiteProvider localeCode={localeCode} translations={translations}>
      <>
        <Component {...pageProps} />
      </>
    </BusinessSiteProvider>
  );
}

MyApp.getInitialProps = async ({ ctx }) => {
  const host = (() => {
    if (typeof window !== 'undefined') {
      return window.location.host;
    }

    if (ctx?.req?.headers?.host) {
      return ctx.req.headers.host;
    }

    return 'business.trustpilot.com';
  })();

  const locale = getLocaleByHost(host);

  const translations = await buildTranslations(locale.code);

  return {
    locale,
    translations,
  };
};

export default MyApp;
